import React from 'react';
import Settings from '../../components/settings';

const SettingsContainer = () => {
    return <Settings />;
};

export default SettingsContainer;
